import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { lastUpdatedLink } from "./lastUpdated";

// In production the API is served from the same origin by Azure Static Web
// Apps, and in development the CRA dev server proxies /api to the local
// Functions host (see "proxy" in package.json).
export const API_URL = process.env.REACT_APP_API_URL || "/api/proxy";

const client = new ApolloClient({
    link: lastUpdatedLink("StationInfo").concat(
        createHttpLink({ uri: API_URL })
    ),
    cache: new InMemoryCache(),
});

export default client;
